var map = {
	"./bh-ico-active.svg": 1789,
	"./bh-ico.svg": 1790,
	"./bonus-ico-active.svg": 1791,
	"./bonus-ico.svg": 1792,
	"./deposit-ico.svg": 1793,
	"./deposit-ico.webp": 1794,
	"./edit-icon.svg": 1795,
	"./fb-ico.svg": 1796,
	"./instant-rebate-ico-active.svg": 1797,
	"./instant-rebate-ico.svg": 1798,
	"./mall-ico-active.svg": 1799,
	"./mall-ico.svg": 1800,
	"./msg-ico-active.svg": 1801,
	"./msg-ico.svg": 1802,
	"./pi-ico-active.svg": 1803,
	"./pi-ico.svg": 1804,
	"./rf-ico-active.svg": 1805,
	"./rf-ico.svg": 1806,
	"./rh-ico-active.svg": 1807,
	"./rh-ico.svg": 1808,
	"./th-ico-active.svg": 1809,
	"./th-ico.svg": 1810,
	"./vip-ico-active.svg": 1811,
	"./vip-ico.svg": 1812,
	"./withdrawal-ico.svg": 1813,
	"./withdrawal-ico.webp": 1814,
	"./wl-ico-active.svg": 1815,
	"./wl-ico.svg": 1816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;